import { render } from "./LanguageChanger.vue?vue&type=template&id=6460140d&ts=true&lang=pug"
import script from "./LanguageChanger.vue?vue&type=script&lang=ts"
export * from "./LanguageChanger.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__